function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON, Object, String, contextPanelTransform, isOpen, searchFilter, sectionFromInputFn, tooltipData) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'select-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        const {
          leftIcon,
          rightIcon
        } = $helpers.getIcon();;
        const THEME = $helpers.THEME;;
        const theme = $attr(`theme`);;
        const tooltip = $attr(`tooltip`);;
        __jade_nodes = __jade_nodes.concat((!isOpen && tooltip) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
            "attrs": {
              placement: tooltip.placement || `top`,
              'always-show': tooltip['always-show'] || false,
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(tooltip.text);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined); /*  TODO: theme button, secondary, tertiary can now be achieved by using button inside the trigger slot */
        /*  using theme button inside mp-select is deprecated */
        /*  once no components are using it, delete the special if conditions around button themes */
        __jade_nodes = __jade_nodes.concat((theme === THEME.TERTIARY || theme === THEME.SECONDARY) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": {
              theme: $attr(`button-theme`) || theme,
              icon: leftIcon,
              size: `small`,
              disabled: $attr(`disabled`),
              pressed: isOpen,
              focusable: false,
            },
            "on": {
              click: () => $component.setDropMenuIsOpen(!isOpen)
            },
            "class": {
              'select-button-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.hasSelectedLabel()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'select-label': true
                },
              }, [__vjadeSafeCode($helpers.selectedLabel())]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : (theme === THEME.BUTTON) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-button", {
            "attrs": {
              theme: `secondary`,
              size: `small`,
              icon: leftIcon,
              disabled: $attr(`disabled`),
              pressed: isOpen,
              focusable: false,
            },
            "on": {
              click: () => $component.setDropMenuIsOpen(!isOpen)
            },
            "class": {
              'select-button-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.hasSelectedLabel()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'select-label': true
                },
              }, [__vjadeSafeCode($helpers.selectedLabel())]));;
              return __jade_nodes
            }).call(this)) : undefined);
            __jade_nodes = __jade_nodes.concat((rightIcon) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: rightIcon
                },
                "class": Object.assign({}, {
                  'select-has-label': $helpers.hasSelectedLabel()
                }, {
                  'right-icon': true
                }),
              }));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "on": {
              click: () => $component.setDropMenuIsOpen(!isOpen)
            },
            "class": {
              'select-button-wrapper': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`trigger`)) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("slot", {
                "attrs": {
                  name: `trigger`
                },
              }));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("span", {
                "class": {
                  'select-button': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((leftIcon) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: leftIcon
                    },
                    "class": {
                      'left-icon': true
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("span", {
                  "class": {
                    'select-label': true
                  },
                }, [__vjadeSafeCode($helpers.selectedLabel())]));
                __jade_nodes = __jade_nodes.concat((rightIcon) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                    "attrs": {
                      icon: rightIcon
                    },
                    "class": {
                      'right-icon': true
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this))); /*  putting if block here to conserve dom memory and only load options list until opened */
        __jade_nodes = __jade_nodes.concat((isOpen) ? ((function() {
          var __jade_nodes = [];
          const isSearchable = $helpers.isSearchable();;
          const menuWidth = $helpers.getDropMenuWidth(isSearchable);;
          const menuHeight = $helpers.getDropMenuHeight();;
          const menuPosition = $helpers.getDropMenuPosition(menuWidth);;
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'select-drop-menu-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-drop-menu", {
              "attrs": {
                'caret-pos': JSON.stringify($attr(`caret-pos`)),
                'open': isOpen,
                'with-caret': Boolean($attr(`caret-pos`)),
              },
              "on": {
                change: $helpers.handleDropMenuChange
              },
              "style": menuPosition,
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`body`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("slot", {
                  "attrs": {
                    name: `body`
                  },
                }));;
                return __jade_nodes
              }).call(this)) : ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`header-title`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "style": {
                      'width': `${menuWidth}px`
                    },
                    "class": {
                      'header-title': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(($attr(`back-button`)) ? ((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": {
                          theme: `tertiary`,
                          icon: `caret-left`,
                          title: `Back (⇦ Left Arrow)`
                        },
                        "on": {
                          click: $helpers.handleBackClick
                        },
                        "class": {
                          'back-button': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this)) : undefined);
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'title-text': true
                      },
                    }, [__vjadeSafeCode($attr(`header-title`))]));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat((isSearchable) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-icon-input", {
                    "key": $attr(`header-title`),
                    "style": {
                      'width': `${menuWidth}px`
                    },
                    "attrs": {
                      icon: `search`,
                      placeholder: $attr(`search-placeholder`),
                    },
                    "props": {
                      value: searchFilter
                    },
                    "on": {
                      input: $helpers.handleSearchInput
                    },
                    "hook": {
                      insert: ({
                        elm
                      }) => $helpers.focusSearchInput(elm),
                      destroy: () => $component.focus(),
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
                  "key": $attr(`header-title`),
                  "style": {
                    'width': `${menuWidth}px`,
                    'max-height': `${menuHeight}px`,
                  },
                  "attrs": {
                    multiple: $attr(`multiple`),
                    'show-select-all': $attr(`show-select-all`),
                    'search-filter': searchFilter,
                    'empty-message': `This list is empty`,
                  },
                  "props": {
                    sections: $helpers.getItemsMenuSections(),
                    sectionFromInputFn,
                    keydownProxyEl: $component,
                  },
                  "on": {
                    clickItem: $helpers.handleClickItem,
                    focusItem: $helpers.handleFocusItem,
                    selectAll: $helpers.handleSelectAll,
                  },
                }));
                __jade_nodes = __jade_nodes.concat((contextPanelTransform) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
                    "attrs": {
                      'tooltip-data': JSON.stringify(tooltipData),
                      'position-parent-selector': `mp-drop-menu`,
                    },
                  }));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this))); /*  footer slot */
              __jade_nodes = __jade_nodes.concat(($helpers.hasSlot(`footer`)) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'select-footer': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("slot", {
                    "attrs": {
                      name: `footer`
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "contextPanelTransform" in locals ? locals.contextPanelTransform : typeof contextPanelTransform !== "undefined" ? contextPanelTransform : undefined, "isOpen" in locals ? locals.isOpen : typeof isOpen !== "undefined" ? isOpen : undefined, "searchFilter" in locals ? locals.searchFilter : typeof searchFilter !== "undefined" ? searchFilter : undefined, "sectionFromInputFn" in locals ? locals.sectionFromInputFn : typeof sectionFromInputFn !== "undefined" ? sectionFromInputFn : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;